import React from "react";
import { ManageInvestmentsMasterContainer } from "../../../containers";

const ManageInvestmentsMaster = (props) => {
  return <ManageInvestmentsMasterContainer {...props} />;
};

export default ManageInvestmentsMaster;
